import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd'
import 'antd/dist/antd.css'
import {
    resetAll,
    resetBrand,
    resetDelivery,
    resetIsInStock,
    resetIsOfDealer,
    resetPriceFrom,
    resetPriceTo,
    resetQuantityFrom,
    resetQuantityTo,
    selectBrand,
    selectDelivery,
    selectInitialBrand,
    selectInitialDelivery,
    selectInitialIsInStock,
    selectInitialIsOfDealer,
    selectInitialQuantityFrom,
    selectInitialQuantityTo,
    selectIsFilterApplied,
    selectIsInStock,
    selectIsOfDealer,
    selectPriceFrom,
    selectPriceTo,
    selectQuantityFrom,
    selectQuantityTo
} from './filterSlice'
import cn from 'classnames'
import { selectCurrency } from '../currency/currencySlice'
import setPartsPrice from '../../utils/parts/setPartsPrice'
import parts from '../../utils/constants/parts'

const SlectedFilter = ({ filterHide }) => {
    const dataDelivery = [
        { val: 'now', name: 'Сегодня' },
        { val: 'tomorrow', name: 'Завтра' },
        { val: 'five', name: 'До 5 дней' },
        { val: 'any', name: 'Любой' }
    ]
    const dispatch = useDispatch()

    const isFilterApplied = useSelector(selectIsFilterApplied)

    const priceFrom = useSelector(selectPriceFrom)
    const priceTo = useSelector(selectPriceTo)
    const isInStock = useSelector(selectIsInStock)
    const isOfDealer = useSelector(selectIsOfDealer)
    const delivery = useSelector(selectDelivery)
    const quantityFrom = useSelector(selectQuantityFrom)
    const quantityTo = useSelector(selectQuantityTo)
    const brand = useSelector(selectBrand)

    const initialIsInStock = useSelector(selectInitialIsInStock)
    const initialIsOfDealer = useSelector(selectInitialIsOfDealer)
    const initialDelivery = useSelector(selectInitialDelivery)
    const initialQuantityFrom = useSelector(selectInitialQuantityFrom)
    const initialQuantityTo = useSelector(selectInitialQuantityTo)
    const initialBrand = useSelector(selectInitialBrand)

    const currency = useSelector(selectCurrency)

    const partsWithCurrency = useMemo(() => setPartsPrice(parts, currency), [currency])
    const priceRange = partsWithCurrency.map((part) => Math.floor(part.price_src))

    const maxPrice = Math.max(...priceRange) + 1 // cause floor
    const minPrice = Math.min(...priceRange)

    const isPriceFromFilterApplied = priceFrom > 0 && priceFrom !== minPrice
    const isPriceToFilterApplied = priceTo > 0 && priceTo !== maxPrice
    const isInStockFilterApplied = isInStock !== initialIsInStock
    const isOfDealerFilterApplied = isOfDealer !== initialIsOfDealer
    const isDeliveryFilterApplied = delivery !== initialDelivery
    const isQuantityFromFilterApplied = quantityFrom !== initialQuantityFrom
    const isQuantityToFilterApplied = quantityTo !== initialQuantityTo
    const isBrandToFilterApplied = brand !== initialBrand

    if (!isFilterApplied) return <></>
    return (
        <div className={cn('selected-filter', filterHide)}>
            {isPriceFromFilterApplied && (
                <Button
                    className="selected-filter__button"
                    onClick={() => dispatch(resetPriceFrom())}
                >
                    Цена от {priceFrom}
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
            {isPriceToFilterApplied && (
                <Button
                    className="selected-filter__button"
                    onClick={() => dispatch(resetPriceTo())}
                >
                    Цена до {priceTo}
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
            {isInStockFilterApplied && (
                <Button
                    className="selected-filter__button"
                    onClick={() => dispatch(resetIsInStock())}
                >
                    Только в наличии: {isInStock ? 'да' : 'нет'}
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
            {isOfDealerFilterApplied && (
                <Button
                    className="selected-filter__button"
                    onClick={() => dispatch(resetIsOfDealer())}
                >
                    Оф. дилер: {isOfDealer ? 'да' : 'нет'}
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
            {isDeliveryFilterApplied && (
                <Button
                    className="selected-filter__button"
                    onClick={() => dispatch(resetDelivery())}
                >
                    Доставка: {dataDelivery.filter((row) => row.val === delivery)[0].name}
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
            {isQuantityFromFilterApplied && (
                <Button
                    className="selected-filter__button"
                    onClick={() => dispatch(resetQuantityFrom())}
                >
                    К-ов от {quantityFrom}
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
            {isQuantityToFilterApplied && (
                <Button
                    className="selected-filter__button"
                    onClick={() => dispatch(resetQuantityTo())}
                >
                    К-ов до {quantityTo}
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
            {isBrandToFilterApplied && (
                <Button className="selected-filter__button" onClick={() => dispatch(resetBrand())}>
                    Бренд {brand.join(', ')}
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
            {isFilterApplied && (
                <Button
                    className="selected-filter__button all"
                    onClick={() => dispatch(resetAll())}
                >
                    Очистить все
                    {
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                                fill="black"
                            />
                        </svg>
                    }
                </Button>
            )}
        </div>
    )
}

export default SlectedFilter
